import { Icon as BlueIcon } from '@blueprintjs/core';
import COLORS_FLAT from '@styles/colors/themes/beam/beam-flat';
import Text from '@components/Text/Text';

import { Container } from './AssetMatchLabel.styles';
import { IAssetMatchLabel } from './AssetMatchLabel.types';
import {
  getAssetMatchStatus,
  getAssetMatchIconColor,
  statuses,
} from './AssetMatchLabel.utils';

const AssetMatchLabel = (props: IAssetMatchLabel) => {
  const { status, text = 'p300' } = props;
  const _status = getAssetMatchStatus(status);
  const shade = getAssetMatchIconColor(_status);

  const getIcon = () => {
    const { icon } = statuses[_status];

    return <BlueIcon icon={icon} color={COLORS_FLAT[shade]} size={12} />;
    // if (status === MatchStatus.Identified) {
    //   return <BlueIcon icon="tick-circle" color="#474D66" size={12} />;
    // }
    // if (status === MatchStatus.Inventory) {
    //   return <BlueIcon icon="info-sign" color="#474D66" size={12} />;
    // }
    // if (status === MatchStatus.IdentificationRequested) {
    //   return <BlueIcon icon="history" color="#8F95B2" size={12} />;
    // }

    // return <BlueIcon icon="error" color="#8F95B2" size={12} />;
  };

  const getLabel = () => {
    // if (status === MatchStatus.Identified) {
    //   return 'Identified';
    // }
    // if (status === MatchStatus.Inventory) {
    //   return 'Internal';
    // }
    // if (status === MatchStatus.IdentificationRequested) {
    //   return 'Requested';
    // }
    // if (status === MatchStatus.Error) {
    //   return 'Error';
    // }
    // if (status === MatchStatus.Discarded) {
    //   return 'Discarded';
    // }
    return statuses[_status].label;
    // return statuses[MatchStatus.Unidentified].label;
  };

  return (
    <Container className="new-icon">
      {getIcon()}
      <Text textColor={shade} text={text}>
        {getLabel()}
      </Text>
    </Container>
  );
};

export { AssetMatchLabel };
